import { AlarmModeEnum, BatteryStoreModeEnum, DroneBatteryModeEnum, LinkWorkModeEnum } from '/@/types/airport-tsa'
// 机场指令集
export enum DeviceCmd {
  // 简单指令
  DebugModeOpen = 'debug_mode_open', // 调试模式开启
  DebugModeClose = 'debug_mode_close', // 调试模式关闭
  SupplementLightOpen = 'supplement_light_open', // 打开补光灯
  SupplementLightClose = 'supplement_light_close', // 关闭补光灯
  ReturnHome = 'return_home', // 一键返航
  ReturnHomeCancel = 'return_home_cancel', // 取消返航
  // 复杂指令
  DeviceReboot = 'device_reboot', // 机场重启
  DroneOpen = 'drone_open', // 飞行器开机
  DroneClose = 'drone_close', // 飞行器关机
  // DeviceCheck = 'device_check', // 一键排障（一键起飞自检）
  DeviceFormat = 'device_format', // 机场数据格式化
  DroneFormat = 'drone_format', // 飞行器数据格式化
  CoverOpen = 'cover_open', // 打开舱盖
  CoverClose = 'cover_close', // 关闭舱盖
  PutterOpen = 'putter_open', // 推杆展开
  PutterClose = 'putter_close', // 推杆闭合
  ChargeOpen = 'charge_open', // 打开充电
  ChargeClose = 'charge_close', // 关闭充电
  AlarmStateSwitch = 'alarm_state_switch', // 机场声光报警
  BatteryStoreModeSwitch = 'battery_store_mode_switch', // 电池保养
  DroneBatteryModeSwitch = 'battery_maintenance_switch', // 飞行器电池保养
  SdrWorkModeSwitch = 'sdr_workmode_switch', // 增强图传
}

export type DeviceCmdItemAction = AlarmModeEnum | BatteryStoreModeEnum | DroneBatteryModeEnum | LinkWorkModeEnum

export interface DeviceCmdItem{
  label: string, // 标题
  status: string, // 当前状态
  operateText: string, // 按钮文字
  cmdKey: DeviceCmd, // 请求指令
  oppositeCmdKey?: DeviceCmd, // 相反状态指令
  action?: DeviceCmdItemAction, // 参数
  func: string, // 处理函数
  loading: boolean // 按钮loading
  disabled?: boolean // 按钮disabled
}
export const noDebugCmdList: DeviceCmdItem[] = [
  {
    label: 'Return Home',
    status: '--',
    operateText: 'Return Home',
    cmdKey: DeviceCmd.ReturnHome,
    func: 'returnHome',
    loading: false,
  },
  {
    label: 'Return Home Cancel',
    status: '--',
    operateText: 'Return Home Cancel',
    cmdKey: DeviceCmd.ReturnHomeCancel,
    func: 'returnHomeCancel',
    loading: false,
  }
]

// 机场指令
export const cmdList: DeviceCmdItem[] = [
  {
    // iconName: ,
    // label: '机场系统',
    // status: '工作中',
    // operateText: '重启',
    label: 'Device Reboot',
    status: 'Started',
    operateText: 'Reboot',
    cmdKey: DeviceCmd.DeviceReboot,
    func: 'deviceReboot',
    loading: false,
    // btnAnimationIconName: '',
    // operateTips: '',
    // statusColor: '',
  },
  {
    label: 'Drone Power', // '飞行器',
    status: 'Off', // '关机',
    operateText: 'On', // 开机',
    cmdKey: DeviceCmd.DroneOpen,
    oppositeCmdKey: DeviceCmd.DroneClose,
    func: 'droneStatus',
    loading: false,
  },
  {
    // label: '舱盖',
    label: 'Dock Cover',
    // status: '关',
    // operateText: '开启',
    status: 'Closed',
    operateText: 'Open',
    cmdKey: DeviceCmd.CoverOpen,
    oppositeCmdKey: DeviceCmd.CoverClose,
    func: 'coverStatus',
    loading: false,
  },
  {
    label: 'Putter', // '推杆',
    status: 'Closure', // '闭合',
    operateText: 'Expand', // '展开',
    cmdKey: DeviceCmd.PutterOpen,
    oppositeCmdKey: DeviceCmd.PutterClose,
    func: 'putterStatus',
    loading: false,
  },
  {
    label: 'Charging Status', // '充电状态',
    status: 'Not Charged', // '未充电',
    operateText: 'Charge', // '充电',
    cmdKey: DeviceCmd.ChargeOpen,
    oppositeCmdKey: DeviceCmd.ChargeClose,
    func: 'chargeStatus',
    loading: false,
  },
  {
    label: 'Device Storage', // '机场存储',
    status: '--',
    operateText: 'Format', // '格式化',
    cmdKey: DeviceCmd.DeviceFormat,
    func: 'deviceFormat',
    loading: false,
  },
  {
    label: 'Aircraft Storage', // '飞行器存储',
    status: '--',
    operateText: 'Format', // '格式化',
    cmdKey: DeviceCmd.DroneFormat,
    func: 'droneFormat',
    loading: false,
  },
  {
    label: 'Status Light', // '补光灯',
    status: 'Off', // '关',
    operateText: 'On', // 打开',
    cmdKey: DeviceCmd.SupplementLightOpen,
    oppositeCmdKey: DeviceCmd.SupplementLightClose,
    func: 'supplementLightStatus',
    loading: false,
  },
  {
    label: 'Alarm', // '机场声光报警',
    status: 'Off', // '关',
    operateText: 'On', // '打开',
    cmdKey: DeviceCmd.AlarmStateSwitch,
    action: AlarmModeEnum.OPEN,
    func: 'alarmState',
    loading: false,
  },
  {
    label: 'Battery Storage Mode', // '机场电池存储模式',
    status: 'Plan', // '计划',
    operateText: 'Emergency', // '应急',
    cmdKey: DeviceCmd.BatteryStoreModeSwitch,
    action: BatteryStoreModeEnum.BATTERY_EMERGENCY_STORE,
    func: 'batteryStoreMode',
    loading: false,
  },
  {
    label: 'Drone Battery', // '飞机电池保养',
    status: '--',
    operateText: 'Maintain', // '保养',
    cmdKey: DeviceCmd.DroneBatteryModeSwitch,
    action: DroneBatteryModeEnum.OPEN,
    func: 'droneBatteryMode',
    loading: false,
    disabled: true,
  },
  {
    label: '4G Enhancement',
    status: '--',
    operateText: 'On',
    cmdKey: DeviceCmd.SdrWorkModeSwitch,
    action: LinkWorkModeEnum.FourG_FUSION_MODE,
    func: 'sdrWorkMode',
    loading: false,
  },
]

export enum DeviceCmdStatusText {
  DeviceRebootNormalText = 'Working', // 工作中
  DeviceRebootInProgressText = 'Rebooting...', // 重启中...
  DeviceRebootFailedText = 'Reboot failed', // 重启失败

  DroneStatusOpenNormalText = 'On', // 开
  DroneStatusOpenInProgressText = 'Powering on...', // 开机中...
  DroneStatusOpenFailedText = 'Off', // 关
  DroneStatusOpenBtnText = 'Power off', // 关机

  DroneStatusCloseNormalText = 'Off', // 关
  DroneStatusCloseInProgressText = 'Powering off...', // 关机中...
  DroneStatusCloseFailedText = 'On', // 开
  DroneStatusCloseBtnText = 'Power on', // 开机

  DeviceCoverOpenNormalText = 'Open', // 开
  DeviceCoverOpenInProgressText = 'Opening...', // 开启中...
  DeviceCoverOpenFailedText = 'Closed', // 关
  DeviceCoverOpenBtnText = 'Close', // 关闭

  DeviceCoverCloseNormalText = 'Closed', // 关
  DeviceCoverCloseInProgressText = 'Closing...', // 关闭中...
  DeviceCoverCloseFailedText = 'Open', // 开
  DeviceCoverCloseBtnText = 'Open', // 开启

  DevicePutterOpenNormalText = 'Extend', // 展开
  DevicePutterOpenBtnText = 'Retract', // 闭合
  DevicePutterOpenInProgressText = 'Extending...', // 推杆展开中
  DevicePutterOpenFailedText = 'Retracted', // 闭合

  DevicePutterCloseNormalText = 'Retracted', // 闭合
  DevicePutterCloseInProgressText = 'Retracting...', // 推杆闭合中
  DevicePutterCloseFailedText = 'Extend', // 展开
  DevicePutterCloseBtnText = 'Extend', // 展开

  DeviceChargeOpenNormalText = 'Charging', // 充电
  DeviceChargeOpenInProgressText = 'Charging...', // 充电中...
  DeviceChargeOpenFailedText = 'Charge Failed', // 未充电
  DeviceChargeOpenBtnText = 'Stop', // 断电

  DeviceChargeCloseNormalText = 'Not Charged', // 断电
  DeviceChargeCloseInProgressText = 'Stopping Charge...', // 断电中...
  DeviceChargeCloseFailedText = 'Cannot Stop Charging', // 充电
  DeviceChargeCloseBtnText = 'Charge', // 充电

  DeviceFormatInProgressText = 'Formatting...', // 格式化...
  DeviceFormatFailedText = 'Format failed', // 格式化失败

  DroneFormatInProgressText = 'Formatting...', // 格式化...
  DroneFormatFailedText = 'Format failed', // 格式化失败

  DeviceSupplementLightOpenNormalText = 'On', // 开
  DeviceSupplementLightOpenInProgressText = 'Turning on...', // 开启中...
  DeviceSupplementLightOpenFailedText = 'Off', // 关
  DeviceSupplementLightOpenBtnText = 'Turn off', // 关闭

  DeviceSupplementLightCloseNormalText = 'Off', // 关
  DeviceSupplementLightCloseText = 'Turning off...', // 关闭中...
  DeviceSupplementLightCloseFailedText = 'On', // 开
  DeviceSupplementLightCloseBtnText = 'Turn on', // 打开

  AlarmStateOpenNormalText = 'On', // 开
  AlarmStateOpenText = 'Turning on...', // 开启中...
  AlarmStateOpenFailedText = 'Off', // 关
  AlarmStateOpenBtnText = 'Turn off', // 关闭

  AlarmStateCloseNormalText = 'Off', // 关
  AlarmStateCloseText = 'Turning off...', // 关闭中...
  AlarmStateCloseFailedText = 'On', // 开
  AlarmStateCloseBtnText = 'Turn on', // 打开

  BatteryStoreModePlanNormalText = 'Planned', // 计划
  BatteryStoreModePlanText = 'Switching...', // 切换中...
  BatteryStoreModePlanFailedText = 'Emergency', // 应急
  BatteryStoreModePlanBtnText = 'Emergency', // 应急

  BatteryStoreModeEmergencyNormalText = 'Emergency', // 应急
  BatteryStoreModeEmergencyText = 'Switching...', // 切换中...
  BatteryStoreModeEmergencyFailedText = 'Planned', // 计划
  BatteryStoreModeEmergencyBtnText = 'Planned', // 计划

  DroneBatteryModeMaintenanceInProgressText = 'Maintaining', // 保养中
  DroneBatteryModeMaintenanceNotNeedText = 'Normal', // 无需保养
  DroneBatteryModeMaintenanceNeedText = 'Need Maintenance', // 需保养
  DroneBatteryModeOpenBtnText = 'Maintain', // 保养
  DroneBatteryModeCloseBtnText = 'Stop maintenance', // 关闭保养

  SdrWorkModeFourGOpenNormalText = 'On', // 开
  SdrWorkModeFourGOpenText = 'Turning on...', // 开启中...
  SdrWorkModeFourGOpenFailedText = '--', // --
  SdrWorkModeFourGOpenBtnText = 'Turn off', // 关闭

  SdrWorkModeFourGCloseNormalText = '--', // --
  SdrWorkModeFourGCloseText = 'Turning off...', // 关闭中...
  SdrWorkModeFourGCloseFailedText = 'On', // 开
  SdrWorkModeFourCloseBtnText = 'Turn on', // 开启
}

// cmd ws 消息状态
export enum DeviceCmdExecuteStatus {
  Sent = 'sent', // 已下发
  InProgress = 'in_progress', // 执行中
  OK = 'ok', // 执行成功
  Failed = 'failed', // 失败
  Canceled = 'canceled', // 取消
  Timeout = 'timeout' // 超时
}

export interface DeviceCmdExecuteInfo {
  biz_code: string,
  timestamp: number,
  sn: string,
  bid: string,
  output:{
    status: DeviceCmdExecuteStatus,
    progress?: {
      percent: number,
      step_key: string,
      step_result: number
    },
    ext?: {
      rate?: number
    }
  }
  result: number,
}

// 所有机场的指令执行状态
export interface DevicesCmdExecuteInfo {
  [key: string]: DeviceCmdExecuteInfo[], // sn --- DeviceCmdExecuteInfo
}
